import React, { useEffect, useState } from "react";
import { DateTime } from "luxon";
import { amountFormatter, useCountdown, useCountdownV2 } from "services";
import BidsHistoryModal from "./bidsHistoryModal";
import { ModalBase, CollapsibleAccordion } from "@reusejs/react";
import { LoadingSpinner } from "./LoadingSpinner";

export default function EventData(props: any) {
  // const [hours, minutes, seconds, isTimeEnded] = useCountdown(
  //   props.endTime,
  //   props.serverTime
  // );
  const [hours, minutes, seconds, isTimeEnded] = useCountdownV2(
    props.endTime,
    props.timeOffset
  );

  const openModal = async (correctBids: any, wrongBids: any) => {
    const BidsHistoryModalWrapper = (props: any) => {
      return (
        <BidsHistoryModal
          correctBids={correctBids}
          userWrongBids={wrongBids}
          {...props}
        />
      );
    };

    await ModalBase(
      {
        content: BidsHistoryModalWrapper,
        timeout: 0,
        backgroundColor: "bg-black/30",
        backgroundOpacity: "opacity-70",
        modalBaseClasses: {
          background: "bg-white",
          border: "border-2 rounded-lg",
          alignment: "text-left overflow-visible",
          padding: "p-0",
          small: "w-full sm:max-w-4xl",
        },
      },
      1000,
      "__next"
    );
  };

  const handleBidsHistory = () => {
    openModal(props.correctBids, props.wrongBids);
  };

  const EventContentData = () => {
    return (
      <div className="border-t border-gray-200 py-5 sm:p-0">
        <dl className="sm:divide-y sm:divide-gray-200">
          <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Auction Brief</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
              {props.data?.event_name}
            </dd>
          </div>
          <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">EMD Amount</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
              ₹ {amountFormatter(props.data?.property_dump?.emd_amount)}
            </dd>
          </div>
          <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Actual Start Time
            </dt>
            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
              {`${DateTime.fromISO(props.data?.start_date_time)
                .setZone("Asia/Kolkata")
                .toFormat("DD hh:mm:ss a")} (IST)`}
            </dd>
          </div>
          <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Actual End Time
            </dt>
            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
              {`${DateTime.fromISO(props.data?.end_date_time)
                .setZone("Asia/Kolkata")
                .toFormat("DD hh:mm:ss a")} (IST)`}
            </dd>
          </div>
          <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Extension Type
            </dt>
            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
              {props.data?.auto_extension_type}
            </dd>
          </div>
          <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Extension At</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
              Last{" "}
              <span className="font-semibold">
                {props.data?.extend_time_at}
              </span>{" "}
              minutes
            </dd>
          </div>
          <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Extension By</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
              <span className="font-semibold">
                {props.data?.extend_time_by}
              </span>{" "}
              minutes
            </dd>
          </div>
        </dl>
      </div>
    );
  };

  const PropertyContentData = () => {
    console.log(
      "props.data?.property_dump",
      props.data?.property_dump?.bank?.name
    );
    return (
      <div className="border-t border-gray-200 py-5 sm:p-0">
        <dl className="sm:divide-y sm:divide-gray-200">
          <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Property ID</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
              {props.data?.property_dump?.property_id}
            </dd>
          </div>
          <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Reserve Price</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
              ₹ {amountFormatter(props.data?.property_dump?.reserve_price)}
            </dd>
          </div>
          <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Property Address
            </dt>
            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0 capitalize">
              {props.data?.property_dump?.address}
            </dd>
          </div>
          <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Bank</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0 capitalize">
              {props.data?.property_dump?.bank?.name}
            </dd>
          </div>
          <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">State</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0 capitalize">
              {props.data?.property_dump?.state?.name}
            </dd>
          </div>
          <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">City</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0 capitalize">
              {props.data?.property_dump?.city?.name}
            </dd>
          </div>
          <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              View Complete Details
            </dt>
            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
              <span
                className="cursor-pointer hover:text-blue-600"
                onClick={() =>
                  window.open(
                    `${process.env.NEXT_PUBLIC_WEB_URL}auction-properties/${props.data?.property_dump?.listing_id}`,
                    "_blank"
                  )
                }
              >
                Click Here
              </span>
            </dd>
          </div>
        </dl>
      </div>
    );
  };

  const accordionList = [
    {
      labelBaseProps: {
        label: (
          // <div className="px-4 py-5 sm:px-6 flex item-center">
          //   <h3 className="text-lg font-medium leading-6 text-gray-900">
          //     Auction Details
          //   </h3>
          // </div>
          <div className=" flex items-center ">
            <h3 className="text-lg font-medium leading-6 text-gray-900">
              Auction Details
            </h3>
          </div>
        ),
      },
      content: EventContentData,
      accordionBaseClasses: {
        padding: "py-5 px-4 sm:px-6",
        content: "text-gray-900 px-4 sm:px-0 dark:text-white",
        wrapper:
          "border rounded-md border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 mb-3",
      },
    },
    {
      labelBaseProps: {
        label: (
          <div className=" flex items-center ">
            <h3 className="text-lg font-medium leading-6 text-gray-900">
              Property Details
            </h3>
          </div>
        ),
      },
      content: PropertyContentData,
      accordionBaseClasses: {
        padding: "py-5 px-4 sm:px-6",
        content: "text-gray-900 px-4 sm:px-0 dark:text-white",
        wrapper:
          "border rounded-md border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 mb-3",
      },
    },
  ];

  useEffect(() => {
    console.log("isTimeEnded::>", isTimeEnded);
    props.setIsTimeEnded(isTimeEnded);
    (async () => {
      await props.checkBidStatus(isTimeEnded);
    })();
  }, [isTimeEnded]);

  return (
    <>
      <div className="py-2">
        <div className="overflow-hidden bg-white shadow sm:rounded-lg">
          <div className="px-4 py-5 sm:px-6">
            <div className="flex justify-between items-center">
              <h3 className="text-lg font-medium leading-6 text-gray-900">
                Auction Event, ID: {props.data?.listing_id}
                {props.connectionStatus === "Offline" && (
                  <>
                    <p className="mt-1 text-xs text-gray-500">
                      Connection Status:{" "}
                      <span className={"font-bold text-red-500"}>
                        {props.connectionStatus}
                      </span>
                    </p>
                    <p className="text-sm font-medium leading-6 text-red-500">
                      Your internet connection appears to be slow or offline!
                      Connect to high-speed internet for smoother bidding.
                    </p>
                  </>
                )}
                {props.connectionStatus === "Connecting" && (
                  <>
                    <p className="mt-1 text-xs text-gray-500">
                      Connection Status:{" "}
                      <span className={"font-bold text-yellow-500"}>
                        {props.connectionStatus}
                      </span>
                    </p>
                    <p className="text-sm font-medium leading-6 text-yellow-500">
                      Your internet connection appears to be slow or offline!
                      Connect to high-speed internet for smoother bidding.
                    </p>
                  </>
                )}
              </h3>

              {props.connectionStatus !== "Offline" && (
                <div className="flex flex-col w-20 justify-center items-center">
                  {props.status === "live" && (
                    <span className="inline-flex w-16 items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-800">
                      <svg
                        className="-ml-0.5 mr-1.5 h-2 w-2 text-green-400"
                        fill="currentColor"
                        viewBox="0 0 8 8"
                      >
                        <circle cx={4} cy={4} r={3} />
                      </svg>
                      Live
                    </span>
                  )}
                  {props.status === "end" && (
                    <span className="inline-flex w-16 items-center rounded-full bg-red-100 px-2.5 py-0.5 text-xs font-medium text-red-800">
                      <svg
                        className="-ml-0.5 mr-1.5 h-2 w-2 text-red-400"
                        fill="currentColor"
                        viewBox="0 0 8 8"
                      >
                        <circle cx={4} cy={4} r={3} />
                      </svg>
                      Ended
                    </span>
                  )}
                  <div
                    className={
                      "mt-2 text-lg sm:col-span-2 " +
                      `${
                        props.status === "live" &&
                        props.endTime &&
                        props.endTime -
                          DateTime.now().setZone("Asia/Kolkata").toMillis() <=
                          parseInt(props.data?.extend_time_at) * 60 * 1000
                          ? "text-red-600 font-semibold"
                          : "text-gray-900 font-medium"
                      }`
                    }
                  >
                    {props?.flag ? (
                      <LoadingSpinner />
                    ) : (
                      <>
                        {props.status === "live"
                          ? hours < 10
                            ? hours > 0
                              ? `0${hours}`
                              : "00"
                            : hours
                          : "00"}
                        :
                        {props.status === "live"
                          ? minutes < 10
                            ? minutes > 0
                              ? `0${minutes}`
                              : "00"
                            : minutes
                          : "00"}
                        :
                        {props.status === "live"
                          ? seconds < 10
                            ? seconds > 0
                              ? `0${seconds}`
                              : "00"
                            : seconds
                          : "00"}
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>

            <p className="mt-1 max-w-2xl text-sm text-gray-500">
              Latest Bid Price:
              <span className="font-bold text-gray-900">
                {props.latestBid
                  ? `₹ ${amountFormatter(props.latestBidAmount)}`
                  : "NA"}
              </span>{" "}
              at{" "}
              {props.status !== "end"
                ? `${props.currentTime} (IST)`
                : props.latestBid?.bid_timestamp &&
                  `${DateTime.fromMillis(
                    typeof props.endTime === "string"
                      ? parseInt(props.endTime)
                      : props.endTime
                    // typeof props.latestBid?.bid_timestamp === "string"
                    //   ? parseInt(props.latestBid?.bid_timestamp)
                    //   : props.latestBid?.bid_timestamp
                  )
                    .setZone("Asia/Kolkata")
                    .toFormat("DD hh:mm:ss a")} (IST)`}
            </p>
            {/* {props.latestBid && (
              <p className="mt-1 max-w-2xl text-sm text-gray-500">
                H1:{" "}
                <span className="font-medium text-gray-900">
                  ₹ {amountFormatter(props.latestBid?.bidding_amount)}
                </span>{" "}
                at{" "}
                {props.latestBid?.bid_timestamp &&
                  `${DateTime.fromMillis(
                    typeof props.latestBid?.bid_timestamp === "string"
                      ? parseInt(props.latestBid?.bid_timestamp)
                      : props.latestBid?.bid_timestamp
                  )
                    .setZone("Asia/Kolkata")
                    .toFormat("DD hh:mm:ss a")} (IST)`}
              </p>
            )}
            {props.prevBid && (
              <p className="mt-1 max-w-2xl text-sm text-gray-500">
                H2:{" "}
                <span className="font-medium text-gray-900">
                  ₹ {amountFormatter(props.prevBid?.bidding_amount)}
                </span>{" "}
                at{" "}
                {props.prevBid?.bid_timestamp &&
                  `${DateTime.fromMillis(
                    typeof props.prevBid.bid_timestamp === "string"
                      ? parseInt(props.prevBid?.bid_timestamp)
                      : props.prevBid?.bid_timestamp
                  )
                    .setZone("Asia/Kolkata")
                    .toFormat("DD hh:mm:ss a")} (IST)`}
              </p>
            )} */}
            <div className="flex justify-end">
              <span
                className="text-sm hover:text-blue-600 cursor-pointer"
                onClick={() => handleBidsHistory()}
              >
                Bids History
              </span>
            </div>
          </div>

          <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
            <dl className="sm:divide-y sm:divide-gray-200">
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Your Last Bid
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                  {!props.currentUserLatestBid && "NA"}
                  {props.currentUserLatestBid &&
                    props.currentUserLatestBid?.user_uuid ===
                      props.latestBid?.user_uuid && (
                      <span className="text-green-500 font-bold">
                        ₹{" "}
                        {amountFormatter(
                          props.currentUserLatestBid?.bidding_amount
                        )}{" "}
                        (Rank: 1)
                      </span>
                    )}
                  {props.currentUserLatestBid &&
                    props.currentUserLatestBid?.user_uuid !==
                      props.latestBid?.user_uuid && (
                      <span className="text-red-500 font-bold">
                        ₹{" "}
                        {amountFormatter(
                          props.currentUserLatestBid?.bidding_amount
                        )}
                      </span>
                    )}
                </dd>
              </div>
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Next Possible Bid
                </dt>
                <dd className="mt-1 text-sm text-gray-900 font-semibold sm:col-span-2 sm:mt-0">
                  {props.data.bidding_type === "rp"
                    ? props.latestBidAmount
                      ? typeof props.latestBidAmount === "string"
                        ? `₹ ${amountFormatter(
                            !props.latestBid &&
                              parseInt(props.latestBidAmount) ===
                                parseInt(props.data?.reserve_price)
                              ? parseInt(props.latestBidAmount)
                              : parseInt(props.latestBidAmount) +
                                  parseInt(props.data?.bidding_increment_amount)
                          )} or above(multiples of increment)`
                        : `₹ ${amountFormatter(
                            !props.latestBid &&
                              parseInt(props.latestBidAmount) ===
                                parseInt(props.data?.reserve_price)
                              ? props.latestBidAmount
                              : props.latestBidAmount +
                                  parseInt(props.data?.bidding_increment_amount)
                          )} or above(multiples of increment)`
                      : "₹ 00"
                    : props.latestBidAmount
                    ? typeof props.latestBidAmount === "string"
                      ? `₹ ${amountFormatter(
                          parseInt(props.latestBidAmount) +
                            parseInt(props.data?.bidding_increment_amount)
                        )} or above(multiples of increment)`
                      : `₹ ${amountFormatter(
                          props.latestBidAmount +
                            parseInt(props.data?.bidding_increment_amount)
                        )} or above(multiples of increment)`
                    : "₹ 00"}
                </dd>
              </div>
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Reserve Price
                </dt>
                <dd className="mt-1 text-sm text-gray-900 font-medium sm:col-span-2 sm:mt-0">
                  ₹ {amountFormatter(props.data?.reserve_price)}
                </dd>
              </div>
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Increment Price By
                </dt>
                <dd className="mt-1 text-sm text-gray-900 font-medium sm:col-span-2 sm:mt-0">
                  ₹ {amountFormatter(props.data?.bidding_increment_amount)}
                </dd>
              </div>
              {/* <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Remaining Time
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                  {props.status === "live"
                    ? hours < 10
                      ? `0${hours}`
                      : hours
                    : "00"}
                  :
                  {props.status === "live"
                    ? minutes < 10
                      ? `0${minutes}`
                      : minutes
                    : "00"}
                  :
                  {props.status === "live"
                    ? seconds < 10
                      ? `0${seconds}`
                      : seconds
                    : "00"}
                </dd>
              </div> */}
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  {props.status === "end" ? "Ended At" : "Ends At"}
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                  {props.endTime
                    ? `${DateTime.fromMillis(props.endTime)
                        .setZone("Asia/Kolkata")
                        .toFormat("DD hh:mm:ss a")} (IST)`
                    : "00"}
                </dd>
              </div>
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  {props.status === "live" ? "Started At" : "Starts At"}
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                  {props.startTime
                    ? `${DateTime.fromMillis(props.startTime)
                        .setZone("Asia/Kolkata")
                        .toFormat("DD hh:mm:ss a")} (IST)`
                    : "00"}
                </dd>
              </div>
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Number of Extension
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                  {props.latestBid?.number_of_extension
                    ? props.latestBid?.number_of_extension
                    : "0"}
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </div>

      {/* <div className="py-2">
        <div className="overflow-hidden bg-white shadow sm:rounded-lg">
          <div className="px-4 py-5 sm:px-6">
            <h3 className="text-lg font-medium leading-6 text-gray-900">
              Auction Details
            </h3>
          </div>

          <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
            <dl className="sm:divide-y sm:divide-gray-200">
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Auction Brief
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                  {props.data?.event_name}
                </dd>
              </div>
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  EMD Amount
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                  ₹ {amountFormatter(props.data?.property_dump?.emd_amount)}
                </dd>
              </div>
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Actual Start Time
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                  {DateTime.fromISO(props.data?.start_date_time).toFormat(
                    "DD hh:mm:ss a"
                  )}
                </dd>
              </div>
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Actual End Time
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                  {DateTime.fromISO(props.data?.end_date_time).toFormat(
                    "DD hh:mm:ss a"
                  )}
                </dd>
              </div>
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Extension Type
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                  {props.data?.auto_extension_type}
                </dd>
              </div>
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Extension At
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                  Last{" "}
                  <span className="font-semibold">
                    {props.data?.extend_time_at}
                  </span>{" "}
                  minutes
                </dd>
              </div>
              <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Extension By
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                  <span className="font-semibold">
                    {props.data?.extend_time_by}
                  </span>{" "}
                  minutes
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </div> */}

      <CollapsibleAccordion accordionList={accordionList} />
    </>
  );
}
